import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01a25e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = { ref: "content" }
const _hoisted_3 = { class: "dialog-form-area" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "以下の棋譜を取り込みます。", -1))
const _hoisted_5 = {
  key: 0,
  class: "message"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ※テキストエリアに棋譜を貼り付けてください。")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ※インストールアプリ版では自動的に貼り付けられます。 ")
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { ref: "textarea" }
const _hoisted_11 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (!_ctx.isNative)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("textarea", _hoisted_10, null, 512)
        ])
      ], 512),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOk && _ctx.onOk(...args)))
        }, "取り込む"),
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        }, "キャンセル")
      ])
    ], 512)
  ]))
}